import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlbCabTall } from 'src/app/hojas-call-center/models/AlbCabTall';
import { AnexoDelegacion } from 'src/app/hojas-call-center/models/AnexoDelegacion';
import { RBMatricula } from 'src/app/hojas-call-center/models/RBMatricula';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlbaranTallService
{

  private hostPeticion : string = environment.hojaWSBase;

  constructor(private http: HttpClient){}

  /*
    Recogida de citas :

    SELECT hoja, fec_cita, hora_cita, suc_desc, suc_lloc FROM alb_cab_tall
    WHERE empresa = 2
    AND fec_cita = '2020-05-20'
    AND fec_baj = '0001-01-01';

  */

  getCitasAgendadas(token:string,taller:number,fechaCita:string):Promise<AlbCabTall[]>
  {
    let url:string = this.hostPeticion + "/AlbaranTall/"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
    {
      "parameters":
      [
        [
          {
            "campo": "fec_cita",
            "operacion": "=",
            "valor": fechaCita
            },
          {
          "campo": "delegacio",
          "operacion": "=",
          "valor": taller+""
          },

          {
          "campo": "fec_baj",
          "operacion": "=",
          "valor": "0001-01-01"
          }
        ]
      ],
      "select": ["hoja", "fec_cita", "hora_cita", "suc_desc", "suc_lloc"]
    }
    return new Promise<AlbCabTall[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(response:any)
        {
          if (response && response.length > 4)
            // Acorta el array a los primeros 5 elementos
            resolve(response.slice(0, 5));//QUITAR
          resolve(response);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }

//busca en nuestra BD la matricula.
  //si la encuentra, devolverá los datos del vehiculo
  //Si no , devolvera false conforme no está en BD y que debera de buscarse por DGT
  /*
    Posibles respuestas:

      200 + json --> OK
      400 "matricula no valida para la DGT"
      500 ERROR

  */
  public busquedaMatricula(token:string,matricula:string, extranjera:boolean):Promise<{ tipo: string; datos: Array<any> }>
  {
    let url:string = this.hostPeticion + "/AlbaranTall/buscarMatricula";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    matricula = matricula.trim().toUpperCase();
    let param = {
      matricula: matricula,
      extranjera: extranjera
    }
    //matricula = '"'+matricula+'"';
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,param,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          reject(err);
        },
      });
    });
  }
}
